import { createGlobalStyle } from "styled-components";
import colors from "./colors";

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: "Roboto", "Segoe UI", sans-serif;
    text-rendering: optimizeLegibility !important;
    -webkit-font-smoothing: antialiased !important;
  }

  h1 {
    color: ${colors.text.muted};
    font-weight: normal;
    margin-bottom: 10px;
  }

  .out-of-stock{
    font-size: 14px;
    color: ${colors.errorLight};
    font-style: italic;
  }

  .financial-discount {
    font-size: 14px;
    color: ${colors.successDark};
  }

  .minimumNotReached {
    color: ${colors.errorLight};
  }

  .handshake {
    margin: 0 40px;
  }

  .handshakeInternal {
    margin: 0 10px;
  }

  button {
    border-radius: 12px;
    background: ${colors.primaryLight};
    padding: 10px 16px;
    color: ${colors.text.white};
    border: 0;
    font-size: 15px;
    font-weight: 600;
    box-shadow: 0 2px 8px ${colors.input.focusShadow};
    outline: 0;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover:not(:disabled) {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(126, 185, 205, 0.4);
    }

    &:active:not(:disabled) {
      transform: translateY(0);
    }

    &:disabled {
      color: ${colors.loader.light};
      cursor: not-allowed;
      box-shadow: none;
    }
  }

  .modal {
    background: ${colors.background.main};
    border-radius: 16px;
    width: 50%;
    max-width: 600px;
    outline: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-shadow:
      0 25px 50px rgba(0, 0, 0, 0.15),
      0 10px 30px rgba(0, 0, 0, 0.1);
    animation: modalFadeIn 0.3s ease-out;

    .head {
      display: flex;
      background: ${colors.primary};
      border-radius: 16px 16px 0 0;

      h2 {
        flex: 1;
        text-align: center;
        font-size: 1rem;
        font-weight: 600;
        color: ${colors.text.white};
        margin: 0;
        padding: 20px;
      }

      button {
        margin: 10px;
        padding: 6px 12px;
        background: transparent;
        color: ${colors.modal.headerBtn};
        box-shadow: none;

        &:hover {
          background: rgba(255, 255, 255, 0.1);
          color: ${colors.text.white};
        }
      }
    }

    .content {
      padding: 24px;
      text-align: center;

      p {
        margin-top: 15px;
        color: ${colors.text.secondary};
        line-height: 1.6;
      }
    }
  }

  .ReactModal__Overlay {
    z-index: 1000;
    background-color: rgba(0, 0, 0, 0.5) !important;
    backdrop-filter: blur(4px);
  }

  ul.pagination {
    display: inline-block;
    padding: 0 15px;
    text-align: center;

    li {
      display: inline-block;

      a {
        padding: 8px 16px;
        user-select: none;
        text-decoration: none;
        cursor: pointer;
        border-radius: 8px;
        transition: all 0.2s ease;

        &:hover {
          background-color: ${colors.border.light};
        }
      }

      &.selected a {
        background-color: ${colors.primary};
        color: ${colors.text.white};
        box-shadow: 0 2px 8px ${colors.loader.muted};
      }
    }
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  @keyframes modalFadeIn {
    from {
      opacity: 0;
      transform: translate(-50%, -48%);
    }
    to {
      opacity: 1;
      transform: translate(-50%, -50%);
    }
  }

  .fadein {
    animation: fadeIn 0.5s linear;
  }

  a {
    color: ${colors.primary};
    text-decoration: none;
    transition: color 0.2s ease;

    &:hover {
      color: ${colors.primaryDark};
      text-decoration: underline;
    }
  }
`;

export default GlobalStyle;
